import type { components } from '@/lib/api-types'

type ContractCreate = components['schemas']['ContractCreate']

/** Vorbelegung des Felds „Zahltag“ — dieselbe Zahl wie die Spaltenvorgabe
 * `contracts.payment_due_day` (LUK-44). Wie in den Stammdaten ist das Feld
 * „nicht leerbar“: leer oder ungültig deaktiviert „Anlegen“, den Bereich
 * (1–28) prüft der Server. */
export const DEFAULT_PAYMENT_DUE_DAY = '3'

export interface ContractCreateInput {
  readonly subjectId: string
  readonly tenantId: string
  readonly startsOn: string
  readonly rentCents: number
  readonly paymentDueDay: number
}

/** Rumpf für `POST /contracts`. */
export function contractCreateBody(input: ContractCreateInput): ContractCreate {
  return {
    subject_entity_id: input.subjectId,
    tenant_id: input.tenantId,
    starts_on: input.startsOn,
    base_rent_net_cents: input.rentCents,
    payment_due_day: input.paymentDueDay,
  }
}
